export enum HeaderKey {
  Authorization = 'authorization',
  PosApiWithTenant = 'posApiWithTenant',
  IdentityApi = 'identityApi'
}

export const API_ENDPOINT = {
  auth: {
    url: '/oauth',
    token: '/token',
    userInfo: '/userinfo',
    headers: HeaderKey.Authorization
  },
  admin: {
    url: '/sys/admin',
    initUserSession: '/iam/api/users/change-password/session',
    changePassword: '/iam/api/users/change-password',
    headers: {}
  },
  claim: {
    url: '/api',
    list: '/stores/{storeNo}/claim-requests',
    view: '/stores/{storeNo}/claim-requests/{docNo}',
    fileUrl: '/stores/{storeNo}/claim-requests/imageSignedUrl',
    headers: HeaderKey.PosApiWithTenant
  },
  users: {
    url: '/users',
    get: '/{no}',
    resetPassword: '/{userName}/resetPassword',
    resetPinCode: '/{userName}/resetPinCode',
    activateUser: '/{userName}/activate/{status}',
    createOTP: '/{userName}/otp',
    verifyOTP: '/{userName}/verifyOtp',
    forgotPassword: '/{userName}/forgetPassword',
    forgotUsername: '/{mobileNumber}/forgetUserName',
    forceChangePassword: '/{userName}/forceChangePassword',
    list: '/list',
    headers: HeaderKey.IdentityApi
  },
  stores: {
    url: '/api/stores',
    storesPaging: '/search/store',
    userStore: '/user-stores',
    headers: HeaderKey.PosApiWithTenant
  },
  receipts: {
    url: '/api',
    list: '/stores/{storeNo}/receipts',
    detail: '/stores/{storeNo}/receipts/{receiptNo}',
    agentTransactionDetail: '/stores/{storeNo}/agent-transactions/{receiptNo}',
    create: '/stores/{storeNo}/receipts/{receiptNo}/tax-invoices',
    cancel: '/stores/{storeNo}/tax-invoices/cancel',
    validateCancel: '/stores/{storeNo}/tax-invoices/cancel/validate',
    cancelAndCreate: '/stores/{storeNo}/tax-invoices/cancel-and-create',
    reprint: '/stores/{storeNo}/tax-invoices/reprint',
    validate: '/stores/{storeNo}/receipts/{receiptNo}/tax-invoices/validate',
    rePrintValidate: '/stores/{storeNo}/receipts/{receiptNo}/tax-invoices/reprint-validate',
    printCreditNote: '/stores/{storeNo}/refund/tax-credit-note/print',
    headers: HeaderKey.PosApiWithTenant
  },
  shelf: {
    url: '/api',
    list: '/stores/{storeNo}/shelves',
    view: '/stores/{storeNo}/shelves/fileUrl',
    shelfSequenceList: '/stores/{storeNo}/all-shelves',
    shelfSequenceSubmit: '/stores/{storeNo}/submit-shelf-sequence',
    shelfBarcodePrintList: '/stores/{storeNo}/shelves/barcode/list',
    shelfBarcodePrint: '/stores/{storeNo}/shelves/barcode/print',
    headers: HeaderKey.PosApiWithTenant
  },
  shift: {
    url: '/api',
    list: '/stores/{storeNo}/shifts',
    view: '/stores/{storeNo}/shelves/fileUrl',
    detail: '/stores/{storeNo}/shifts/{docNo}',
    envelopeDetails: '/stores/{storeNo}/shifts/envelopes/details',
    validateActiveDevice: '/stores/{storeNo}/shifts/{documentNo}/force-close/validate-active-device',
    validate: '/stores/{storeNo}/shifts/{documentNo}/force-close/validate',
    submit: '/stores/{storeNo}/shifts/{documentNo}/force-close/submit',
    print: '/stores/{storeNo}/shifts/{documentNo}/print',
    headers: HeaderKey.PosApiWithTenant
  },
  cashSettlements: {
    url: '/api',
    list: '/stores/{storeNo}/cash-settlements',
    detail: '/stores/{storeNo}/cash-settlements/{cashSettlementNo}',
    draft: '/stores/{storeNo}/cash-settlements/draft',
    initial: '/stores/{storeNo}/cash-settlements/initial',
    submit: '/stores/{storeNo}/cash-settlements',
    save: '/stores/{storeNo}/cash-settlements/save',
    history: '/stores/{storeNo}/cash-settlements/history/{cashSettlementNo}',
    print: '/stores/{storeNo}/cash-settlements/{cashSettlementNo}/print',
    masterBank: '/masters/{storeNo}/banks',
    submitTransferEvidence: '/stores/{storeNo}/cash-settlements/transfer-evidence',
    envelopeExchangePlan: '/cash-settlements/envelope-exchange-plan',
    headers: HeaderKey.PosApiWithTenant
  },
  stock: {
    url: '/api/stock',
    list: '/{storeNo}/stocks',
    negativeListCount: '/{storeCode}/negative',
    summary: '/{storeCode}/{articleNo}/summary',
    barcode: '/{articleNo}/barcode',
    movement: '/{storeCode}/{articleNo}/movement',
    adjustTransaction: '/{storeCode}/{articleNo}/pending-adjustment',
    headers: HeaderKey.PosApiWithTenant
  },
  stockTote: {
    url: '/api',
    summary: '/stores/{storeNo}/totes/stock-tote/summary',
    list: '/stores/{storeNo}/totes/stock-tote',
    headers: HeaderKey.PosApiWithTenant
  },
  rtcRequest: {
    url: '/api',
    requestList: '/stores/{storeNo}/rtc-request/pos-manager/list',
    view: '/stores/{storeNo}/rtc-request/pos-manager/view/{docNo}',
    fileUrl: '/stores/{storeNo}/rtc-request/pos-manager/imageSignedUrl',
    headers: HeaderKey.PosApiWithTenant
  },
  rtc: {
    url: '/api',
    list: '/stores/{storeNo}/rtc/pos-manager/list',
    fileUrl: '/imageSignedUrl',
    view: '/stores/{storeNo}/rtc/pos-manager/view/{docNo}',
    history: '/stores/{storeNo}/rtc/pos-manager/history/{docNo}',
    headers: HeaderKey.PosApiWithTenant
  },
  receiveOrder: {
    url: '/api',
    view: '/stores/{storeNo}/receive-orders/{roType}/{docNo}',
    requestList: '/stores/{storeNo}/receive-orders',
    printRO: '/stores/{storeNo}/receive-orders/{roType}/{docNo}/print',
    headers: HeaderKey.PosApiWithTenant
  },
  moneyInOut: {
    url: '/api',
    list: '/stores/{storeNo}/money-in-outs',
    detail: '/stores/{storeNo}/money-in-outs/details',
    headers: HeaderKey.PosApiWithTenant
  },
  masters: {
    url: '/api/masters',
    units: '/{storeNo}/units',
    totes: '/{storeNo}/totes',
    headers: HeaderKey.PosApiWithTenant
  },
  destroy: {
    url: '/api',
    requestList: '/stores/{storeNo}/destroy-requests',
    requestView: '/stores/{storeNo}/destroy-requests/{docNo}',
    requestFileUrl: '/stores/{storeNo}/destroy-requests/image-signed-url',
    list: '/stores/{storeNo}/destroys',
    view: '/stores/{storeNo}/destroys/{docNo}',
    history: '/stores/{storeNo}/destroys/{docNo}/history',
    headers: HeaderKey.PosApiWithTenant
  },
  productTag: {
    url: '/api',
    regularProductTagPrintQueue: '/stores/{storeNo}/product-tag/price-tag/to-do',
    toDoGroupingInfo: '/stores/{storeNo}/product-tag/price-tag/to-do/grouping-info',
    promotionTagToDoGroupingInfo: '/stores/{storeNo}/product-tag/promotion-tag/{type}/to-do/grouping-info',
    printRegular: '/stores/{storeNo}/product-tag/price-tag/print',
    // printPromotion: '/stores/{storeNo}/product-tag/promotion-tag/print',
    printRTC: '/stores/{storeNo}/product-tag/promotion-tag/RTC/print',
    printInfoRTC: '/stores/{storeNo}/product-tag/promotion-tag/RTC/print-info',
    markPrintedRTC: '/stores/{storeNo}/product-tag/promotion-tag/RTC/mark-printed',
    productTagSelector: '/stores/{storeNo}/product-tag/promotion-tag/{type}',
    productTagSelectorPriceTag: '/stores/{storeNo}/product-tag/price-tag',
    productTagPrintQueue: '/stores/{storeNo}/product-tag/promotion-tag/{type}/to-do',
    countProductTag: '/stores/{storeNo}/product-tag/count/{type}',
    countShortLivedTag: '/stores/{storeNo}/product-tag/short-lived/count',
    validateShortLivedTag: '/stores/{storeNo}/product-tag/short-lived/validate',
    submitShortLivedTag: '/stores/{storeNo}/product-tag/short-lived/submit',
    addProductTagSelector: '/stores/{storeNo}/product-tag/promotion-tag/add-to-print',
    addProductPriceTag: '/stores/{storeNo}/product-tag/price-tag/add-to-print',
    resetAllNotification: '/stores/{storeNo}/product-tag/price-tag/reset-notification',
    productTagSettingNotify: '/stores/{storeNo}/product-tag/price-tag/{id}/notify',
    getSpecialFile: '/stores/{storeNo}/product-tag/promotion-tag/SPECIAL/{id}/download/image',
    downloadJob: '/stores/{storeNo}/download-job/{id}',
    submitJob: '/stores/{storeNo}/download-job/submit/{productTagType}',
    deleteTagItems: '/stores/{storeNo}/product-tag/price-tag/delete-requests',
    deletePromotionTagItems: '/stores/{storeNo}/product-tag/promotion-tag/delete-requests',
    validatePriceTag: '/stores/{storeNo}/product-tag/price-tag/add-to-print/validate',
    validatePromotion: '/stores/{storeNo}/product-tag/promotion-tag/add-to-print/validate',
    shelfSequenceList: '/stores/{storeNo}/all-shelves?sortByName=true',
    headers: HeaderKey.PosApiWithTenant
  },
  storeAvailableAdjustment: {
    url: '/api',
    requestList: '/stores/{storeNo}/stock-count-available-adjust-request/list',
    requestView: '/stores/{storeNo}/stock-count-available-adjust-request/view/{docNo}',
    headers: HeaderKey.PosApiWithTenant
  },
  stockCountHistory: {
    url: '/api',
    list: '/stores/{storeNo}/stock-count/stock-count-histories',
    view: '/stores/{storeNo}/stock-count/stock-count-histories/{docNo}',
    headers: HeaderKey.PosApiWithTenant
  },
  storeExpense: {
    url: '/api',
    remaining: '/stores/{storeNo}/store-expense-request/remaining',
    list: '/stores/{storeNo}/store-expense-request',
    view: '/stores/{storeNo}/store-expense-request/{docNo}',
    fileUrl: '/stores/{storeNo}/store-expense-request/fileUrl',
    submitEvidence: '/stores/{storeNo}/store-expense-request/submit-evidence',
    submitSendBackEvidence: '/stores/{storeNo}/store-expense-request/submit-send-back-evidence',
    history: '/stores/{storeNo}/store-expense-request/{docNo}/history',
    cancel: '/stores/{storeNo}/store-expense-request/{docNo}/actions',
    headers: HeaderKey.PosApiWithTenant
  },
  mainPage: {
    url: '/api',
    notification: '/stores/{storeNo}/main-page/notification',
    summary: '/stores/{storeNo}/main-page/sale-summary',
    membershipSummary: '/stores/{storeNo}/memberships/summary',
    // focus sales ไม่มี endpoint แยก — ข้อมูลแนบมาใน productCheerSections ของ dashboardOverview
    dashboardOverview: '/main-page/sale-dashboard/overview?storeCode={storeCode}',
    printDailyWorkInstruction: '/stores/{storeNo}/work-instruction/daily-work-instruction/print',
    shiftSchedules: '/stores/{storeNo}/shift-schedules',
    shiftScheduleDocument: '/stores/{storeNo}/shift-schedules/{week}/document',
    urgentAnnouncement: '/urgent-announcements/latest',
    headers: HeaderKey.PosApiWithTenant
  },
  report: {
    url: '/api/report',
    myReport: '/{storeCode}/my-report',
    downloadReport: '/artifact/{reportNo}',
    salesPerformance: '/sales-performance/export',
    salesTransaction: '/sales-transactions/export',
    shiftRecord: '/shift-record/export',
    countItemInTote: '/count-item-in-tote/export',
    storeOtherIncome: '/store-other-income/export',
    materialRequestTransaction: '/material-request-transaction/export',
    reduceToClearSummary: '/reduce-to-clear-summary/export',
    destroyTransaction: '/destroy-transaction/export',
    storeExpense: '/store-expense/export',
    cafeStock: '/cafe-stock/export',
    productTag: '/check-product-tag/export',
    headers: HeaderKey.PosApiWithTenant
  },
  pdfReport: {
    url: '/api',
    reprintRecallPackedItems: '/stores/{storeCode}/recall/packed-items',
    reprintRecallReturnReceipt: '/stores/{storeCode}/recall/return-receipts',
    headers: HeaderKey.PosApiWithTenant
  },
  memberRewardPickup: {
    url: '/api/member-reward-pickup',
    list: '/{storeCode}',
    confirm: '/confirm',
    history: '/{receiptNo}/history',
    headers: HeaderKey.PosApiWithTenant
  },
  supplierPartnerCoupon: {
    url: '/api/supplier-partner-coupon',
    list: '/list/{storeCode}',
    view: '/detail',
    history: '/history',
    product: '/product',
    headers: HeaderKey.PosApiWithTenant
  },
  productTagPrintingHistory: {
    url: '/api',
    productTagPrintingHistoryList: '/stores/{storeNo}/download-job/product-tag/list',
    headers: HeaderKey.PosApiWithTenant
  },
  stockCheckHistory: {
    url: '/api/recalls',
    list: '/{storeNo}/stock-check/histories',
    view: '/{storeNo}/stock-check/histories/view/{recallNo}',
    detail: '/{storeNo}/stock-check/histories/view/{recallNo}/articles/{articleNo}',
    headers: HeaderKey.PosApiWithTenant
  },
  stockPackingHistory: {
    url: '/api/recalls',
    list: '/{storeNo}/stock-packing/histories',
    view: '/{storeNo}/stock-packing/histories/view/{recallNo}',
    fileUrl: '/documentSignedUrl',
    headers: HeaderKey.PosApiWithTenant
  },
  stockCollectionHistory: {
    url: '/api/recalls',
    list: '/{storeNo}/stock-collection/histories',
    view: '/{storeNo}/stock-collection/histories/view/{docNo}',
    fileUrl: '/documentSignedUrl',
    headers: HeaderKey.PosApiWithTenant
  },
  material: {
    url: '/api/stores',
    requestList: '/{storeNo}/material-request/histories',
    requestView: '/{storeNo}/material-request/histories/view/{docNo}',
    headers: HeaderKey.PosApiWithTenant
  },
  taskAssignment: {
    url: '/api/stores',
    todoList: '/{storeNo}/task-assignment-response/list?status=NO_RESPONSE,SENT_BACK',
    taskAllList: '/{storeNo}/task-assignment-response/list',
    taskAssignment: '/{storeNo}/task-assignment-response/view/{taskId}',
    fileUrl: '/{storeNo}/task-assignment-response/signedUrl',
    submitResponse: '/{storeNo}/task-assignment-response/submit/{responseNo}',
    uploadFile: '/{storeNo}/task-assignment-response/upload/{responseNo}',
    fileUrlPdf: '/{storeNo}/task-assignment-response/download',
    headers: HeaderKey.PosApiWithTenant
  },
  returnToSupplierHistory: {
    url: '/api/stores',
    list: '/{storeCode}/return-to-suppliers',
    view: '/{storeCode}/return-to-supplier/{returnNo}',
    fileUrl: '/{storeCode}/return-to-supplier/image-signed-url',
    print: '/{storeCode}/return-to-supplier/{returnNo}/print',
    headers: HeaderKey.PosApiWithTenant
  }
};
